import { render } from "./BranchAdd.vue?vue&type=template&id=5ea58c60&scoped=true"
import script from "./BranchAdd.vue?vue&type=script&lang=js"
export * from "./BranchAdd.vue?vue&type=script&lang=js"

import "./BranchAdd.vue?vue&type=style&index=0&id=5ea58c60&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ea58c60"]])

export default __exports__